// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"f4cb35e4","277":"0e302a65","536":"eddcd7ea","899":"f23d9fcd","978":"522947d4"}[chunkId] + ".chunk.js";
};